<template>
  <div id="validationId">
    <el-dialog :visible="dialogDisplay" :close-on-click-modal="closeOnClickModal"
      :close-on-press-escape="closeOnPressEscape" :show-close="false" @close="closeModal" :width="width">
      <template #title>
        <div class="dialog-title-box">
          <span>{{ titleText }}</span>
          <rhcn-button class="icon-button dialog-close-icon" size="small" @click="closeDialog"><i
              class="el-icon-close"></i></rhcn-button>
        </div>
      </template>
      <div style="width: 100%;">
        <slot name="prefix"></slot>
        <validation-component ref="validationForm" @afterViewInit="onAfterFormInit"
          :validation-condition="validationCondition">
        </validation-component>
        <slot></slot>
      </div>
      <template #footer>
        <div v-if="submitErrorMessage" class="error-box">{{ submitErrorMessage }}</div>
        <span class="dialog-footer padding-bottom-29">
          <el-button v-if="showCancelButton" @click="handleCancel">{{ $t('message.tableCommon.cancel')
            }}</el-button>
          <el-button v-if="isShowButton" type="primary" :disabled="submitDisabled" @click="handleDetermine"
            :loading="isButtonLoading">{{ submitButtonText || $t('message.common.submit') }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>

import RhcnButton from '@/components/form/button.vue';
import { ShowSuccessMessage } from '@/components/modal/tips/message-tips.js';
import ValidationComponent from '@/components/validation/validation.vue';
import { shallowClones } from '@/utils/tools/utils.js';

export default {
  name: 'ValidationModal',
  components: {
    ValidationComponent,
    RhcnButton,
  },
  props: {
    titleText: {
      type: String,
      default: '提示',
    },
    width: {
      type: String,
      default: '510px',
    },
    /**
     *  Form条件
     */
    validationCondition: {
      type: Array,
      default: () => [],
    },
    /**
     * 点击确定按钮调用的方法
     */
    defaultFunction: {
      type: Function,
      default: null,
    },
    /**
     * 点击确定按钮后如果需要对最后参数进行调整时候调用
     * 需要返回参数(Json格式)
     */
    adjustParameters: {
      type: Function,
      default: null,
    },
    /**
     *  提交之前再次判断表单内容是否正确
     */
    beforeSubmitJudgement: {
      type: Function,
      default: null,
    },
    /**
     * 点击透明部分是否关闭弹框(false为点击外部不关闭)
     */
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    /**
     * 按下ESC键是否关闭弹框(false为点击不关闭)
     */
    closeOnPressEscape: {
      type: Boolean,
      default: true,
    },
    submitSuccessTip: {
      type: String,
      default: 'message.submitSuccessfulTip',
    },
    isShowButton: {
      type: Boolean,
      default: true,
    },
    submitButtonText: {
      type: String,
      default: '',
    },
    submitErrorMessage: {
      type: String,
      default: '',
    },
    showSubmitMessage: {
      type: Boolean,
      default: true,
    },
    submitDisabled: {
      type: Boolean,
      default: false,
    },
    // 外部关闭函数
    customCloseFn: {
      type: Function,
      default: null,
    },
    // 是否启用外部关闭
    customCloseState: {
      type: Boolean,
      default: true,
    },
    showCancelButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogDisplay: false,
      isButtonLoading: false,
      modifyFunction: null,
      modifyData: null,
    };
  },
  methods: {
    getForm() {
      return this.$refs.validationForm;
    },
    openModal(isFormReset = true) {
      this.dialogDisplay = true;
      if (isFormReset && this.getForm()) {
        this.getForm().formReset();
      }
    },
    openModalAndCallBack(callBack, isFormReset = true) {
      this.openModal(isFormReset);
      if (callBack) {
        const count = setTimeout(() => {
          callBack(this.getForm());
          clearTimeout(count);
        });
      }
    },
    closeModal() {
      if (this.customCloseState) {
        this.dialogDisplay = false;
        this.modifyFunction = null;
        this.modifyData = null;
        this.isButtonLoading = false;
      }
    },
    closeDialog() {
      if (!this.customCloseState) {
        const submitFunction = this.customCloseFn;
        submitFunction();
        // return
      } else {
        this.dialogDisplay = false;
      }
    },
    closeMoadalFn() {
      this.dialogDisplay = false;
      this.modifyFunction = null;
      this.modifyData = null;
      this.isButtonLoading = false;
    },
    /**
     * 修改时用（data:需要添加的参数;modifyFunc:修改时使用的方法）
     */
    setModifyCondition(data, modifyFunc) {
      this.modifyData = data;
      this.modifyFunction = modifyFunc;
    },
    httpSubmit() {
      if (this.defaultFunction || this.modifyFunction) {
        let params = this.modifyData ? shallowClones(this.getForm().getFormJson(), this.modifyData) : this.getForm().getFormJson();
        if (!this.beforeSubmitJudgement || (this.beforeSubmitJudgement && this.beforeSubmitJudgement(params))) {
          this.isButtonLoading = true;
          params = this.adjustParameters ? this.adjustParameters(params) : params;
          const submitFunction = this.modifyFunction || this.defaultFunction;
          submitFunction(params).then((data) => {
            this.closeModal();
            this.showSubmitMessage && ShowSuccessMessage(this.$t(this.submitSuccessTip));
            this.$emit('refresh', data);
            this.isButtonLoading = false;
          }).catch(
            () => {
              // ShowErrorMessage('操作失败');
              this.isButtonLoading = false;
            },
          );
        }
      }
    },
    handleDetermine() {
      if (this.operating) { // 防止快速点击
        return;
      }
      this.operating = true;
      setTimeout(() => {
        this.operating = false;
      }, 200);
      this.getForm().toFormValid(this.httpSubmit);
    },
    onAfterFormInit() {
      this.$emit('afterModalFormInit');
    },
    closeDialogFn() {
      this.dialogDisplay = false;
      this.modifyFunction = null;
      this.modifyData = null;
      this.isButtonLoading = false;
    },
    handleCancel() {
      this.dialogDisplay = false;
    },
  },
  mounted() {
  },
};
</script>
<style lang="scss" scope>
@import '@/styles/variables.scss';

#validationId {
  .el-dialog__body {
    display: flex;
    justify-content: center;
    padding: 0 30px;
    padding-top: 20px;
  }

  .dialog-footer {
    display: flex;
    justify-content: center;

    .el-button {
      flex: 1;
    }
  }

  .el-dialog__header {
    height: 64px;
    padding: 0;
    padding-left: 30px;
    padding-right: 20px;
    border-bottom: 1px solid rgba(0, 32, 63, 0.08);
    font-size: 20px;
    font-family: Avenir-Heavy, Avenir;
    font-weight: 800;
    color: $color-text-primary;
    line-height: 36px;
  }

  .el-dialog__footer {
    font-size: 14px;
    font-family: Avenir-Heavy, Avenir;
    font-weight: 800;
    color: #FFFFFF;
    line-height: 36px;
    padding: 20px 30px;
    padding-bottom: 27px;

    .error-box {
      text-align: left;
      color: $color-danger;
      line-height: 1.2;
    }
  }

  .dialog-title-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;

    .dialog-close-icon {
      font-size: 23px;
      width: 27px !important;
      height: 27px !important;
      min-width: 27px !important;
      border-radius: 4px;

      span {
        display: inline-block;
        width: 20px;
        height: 20px;
        display: flex;
      }

      .el-icon-close {
        font-weight: bold;
        font-size: 20px;
        display: inline-block;
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>
